'use client';

const PIN_STORAGE_PREFIX = 'pin-';
const PIN_STORAGE: Storage | undefined =
  typeof window !== 'undefined' ? window.sessionStorage : undefined;

const encodeString = (str: string): string => {
  return btoa(str);
};

const decodeString = (encoded: string): string => {
  return atob(encoded);
};

export const getPersistedPin = (mpi: number): string | undefined => {
  const result = PIN_STORAGE?.getItem(encodeString(PIN_STORAGE_PREFIX + mpi));
  if (!result) return undefined;
  return decodeString(result);
};

export const setPersistedPin = (mpi: number, pin: string): void => {
  PIN_STORAGE?.setItem(
    encodeString(PIN_STORAGE_PREFIX + mpi),
    encodeString(pin),
  );
};
